import { Outlet, createRootRoute } from "@tanstack/react-router";
import { FourOhFourPage } from "@pages/four-oh-four-page";
export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: FourOhFourPage,
});
